const theme = {
  colors: {
    primary: {
      main: '#6B4EF5',
      gradient:
        'linear-gradient(91deg, #6B4EF5 0%, #6C4EF5 0.01%, #7B47EC 100%)',
      solid: '#5D31E8',
      light:
        'linear-gradient(91deg, rgba(107, 78, 245, 0.10) 0%, rgba(108, 78, 245, 0.10) 0.01%, rgba(123, 71, 236, 0.10) 100%)',
    },
    background: {
      grey: '#F4F4F4',
      white: '#ffffff',
    },
    text: {
      black: '#2F2F2F',
      grey: '#AFAFAF',
      darkGrey: '#959595',
      accent: '#ea4726',
    },
    border: {
      grey: '#EAEAEA',
    },
  },
  fonts: {
    body: 'Noto Sans KR, sans-serif',
    description: 'Roboto, sans-serif',
  },
  config: {
    headerHeight: '56px',
    navigationHeight: '60px',
  },
};

export default theme;
